// extracted by mini-css-extract-plugin
export default {"Header":"RatingView_Header__m2GQJ","Label":"RatingView_Label__9yDuD","NotUseButton":"RatingView_NotUseButton__H7dMB","UseButton":"RatingView_UseButton__JRflU"};